var React = require('react');

function CheckmarkCircleInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"currentColor","fillRule":"evenodd","d":"M12 0c6.627 0 12 5.373 12 12s-5.373 12-12 12S0 18.627 0 12 5.373 0 12 0zm4.406 7.275l-6.639 6.738-3.173-3.222-1.284 1.397 4.458 4.524 7.922-8.04-1.284-1.397z"}));
}

CheckmarkCircleInline.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24"};

module.exports = CheckmarkCircleInline;

CheckmarkCircleInline.default = CheckmarkCircleInline;
